<div class="as-modal-container">
    <p>¿Estás seguro de cambiar de tipo de sucursal?</p>
    <p>Es posible que algunos de los productos de tu carrito no se encuentren.</p>
    <div class="btn-container">
        <button mat-stroked-button color="accent" (click)="closeModal(false)">{{ 'STORES.cancel' | translate }}</button>
        <button mat-flat-button color="accent" (click)="closeModal(true)">{{ 'STORES.accept' | translate }}</button>
    </div>
</div>